import { Progress } from '@talentmesh/ui/components/progress';
import { cn } from '@talentmesh/ui/lib/utils';

import { type MRT_RowData, type MRT_TableInstance } from '../../types';
import { parseFromValuesOrFunc } from '../../utils/utils';
import classes from './MRT_ProgressBar.module.css';

interface Props<TData extends MRT_RowData> extends React.ComponentProps<typeof Progress> {
    isTopToolbar: boolean;
    table: MRT_TableInstance<TData>;
}

export const MRT_ProgressBar = <TData extends MRT_RowData>({ isTopToolbar, table, ...rest }: Props<TData>) => {
    const {
        getState,
        options: { mantineProgressProps },
    } = table;
    const { isSaving, showProgressBars } = getState();

    const linearProgressProps = {
        ...parseFromValuesOrFunc(mantineProgressProps, {
            isTopToolbar,
            table,
        }),
        ...rest,
    };

    if (!isSaving && !showProgressBars) {
        return null;
    }

    return (
        <div className={cn(classes.collapse, 'overflow-hidden', isTopToolbar && classes['collapse-top'])}>
            <Progress
                indeterminate
                aria-busy="true"
                aria-label="Loading"
                {...(linearProgressProps as React.ComponentProps<typeof Progress>)}
                className={cn('h-1 rounded-none', linearProgressProps?.className)}
            />
        </div>
    );
};
